import React, { Fragment, useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

import Header from "./components/Header/Header";
import useAuthState from "./hooks/useAuthState";
import HomePage from "./pages/HomePage";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import CreatePage from "./pages/CreatePage";
import ReviewPage from "./pages/ReviewPage";
import CollectionPage from "./pages/CollectionPage";
import SignupPage from "./pages/SignupPage";

function App() {
  const isSignedIn = useAuthState();
  const [inputLang, setInputLang] = useState("en");
  const [outputLang, setOutputLang] = useState("ko");
  const [kCardsCollection, setKCardsCollection] = useState([]);

  // GET USER KCARD COLLECTION
  useEffect(() => {
    if (!isSignedIn) return;

    const fetchKCards = async function () {
      const q = query(
        collection(db, "kcards"),
        where("user", "==", auth.currentUser.uid)
      );
      const querySnapshot = await getDocs(q);
      setKCardsCollection(querySnapshot.docs.map((doc) => doc.data()));
    };

    fetchKCards().catch((error) => console.log(error));
  }, [isSignedIn]);

  // GET USER LANGUAGE PREFERENCES TODO: probably better way to handle this
  useEffect(() => {
    const userLang = localStorage.getItem("userLang");
    if (!userLang) return;

    const { userInputLang, userOutputLang } = JSON.parse(userLang);
    setInputLang(userInputLang);
    setOutputLang(userOutputLang);
  }, [inputLang, outputLang]);

  return (
    <Fragment>
      <Header
        isSignedIn={isSignedIn}
        inputLang={inputLang}
        outputLang={outputLang}
      ></Header>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {!isSignedIn && (
          <Fragment>
            <Route path="/signup" element={<SignupPage />} />
            <Route
              path="/login"
              element={<LoginPage isSignedIn={isSignedIn} />}
            />
          </Fragment>
        )}
        {isSignedIn && (
          <Fragment>
            <Route
              path="/create-kcard"
              element={
                <CreatePage
                  inputLang={inputLang}
                  outputLang={outputLang}
                  updateLocalCollection={setKCardsCollection}
                  collection={kCardsCollection}
                />
              }
            />
            <Route
              path="/my-kcards"
              element={
                <CollectionPage
                  collection={kCardsCollection}
                  updateLocalCollection={setKCardsCollection}
                />
              }
            />
            <Route
              path="/review"
              element={<ReviewPage collection={kCardsCollection} />}
            />
          </Fragment>
        )}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Fragment>
  );
}

export default App;
